/*
 * @Author: your name
 * @Date: 2020-04-22 16:31:24
 * @LastEditTime: 2020-08-11 17:44:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \finfosoft-auth-web\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import service from './public/server.js';
import url from './public/url.js';
import 'element-ui/lib/theme-chalk/index.css';



Vue.config.productionTip = false; //设置为 false 以阻止 vue 在启动时生成生产提示
Vue.use(ElementUI);

Vue.prototype.$http = service;
Vue.prototype.$url = url;

router.beforeEach(async (to, from, next) => { //拦截器
  if(to.name === 'insureSuccess'){
    next();
  }
  const that = Vue.prototype;
  if (sessionStorage.getItem('access_token')) {
    next();
  } else if (location.href.search('code=') != -1) {
    const state = location.href.split('state=')[1].split('&')[0].split('#/')[0];
    sessionStorage.setItem("customer_id", state)
    const code = location.href.split('code=')[1].split('&')[0].split('#/')[0];
    const res = await that.$http.get(`${that.$url.globalurl}/wechatLogin/${code}?customer_id=${state}`);
    sessionStorage.setItem("access_token", res.access_token)
    next()
  }
});
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')